// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ToolTip_tooltip__2MyVV","tooltiptext":"ToolTip_tooltiptext__1yVqk"};